import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import UserState from '../types/UserState'
import moment from 'moment-timezone'
import { timezoneTime } from "@vue-storefront/core/helpers";

export const module: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    token: '',
    refreshToken: '',
    groupToken: '',
    groupId: null,
    current: null,
    current_storecode: '',
    session_started: timezoneTime(),
    orders_history: [],
    ordered_locations: [],
    current_page: 0,
    last_page: 0,
    order: {},
    orderAgeConfirmation: {},
    local_data_loaded: false,
    headers: {}
  },
  getters,
  actions,
  mutations
}
